import React from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'
import styles from './AbilityExample.module.scss'
import { getRespondent, getGMA, startGMA } from 'ducks/respondent'
import { WaveContainer } from 'components/quiz/WaveContainer/WaveContainer'
import { BoldButton } from 'components/shared/BoldButton/BoldButton'
import { t } from 'ttag'
import PlayIcon from 'assets/icons/play.svg'
import Illustration from 'components/common/Illustration'
import { formatTimeVerbose } from 'utils/stringFormat'

export const AbilityExample = ({ secondsLeft, startGMA }) => {
  const verboseTime = formatTimeVerbose(secondsLeft)

  return (
    <WaveContainer rollUp>
      <div className={styles.example}>
        <div className={styles.title}>{t`Example task`}</div>
        <div className={styles.paragraph}>
          {t`Each task consists of nine squares, where you have to identify the pattern that fits into the last square.`}{' '}
          {t`In this example the correct answer is the top left of the six choices.`}
        </div>
        <Illustration className="gma-example" name="gma-example-01" />
        <div className={styles.paragraph}>
          {t`The test will start when you press “Start the test“.`} <br />
          {t`You have`} <b>{verboseTime}</b> {t`to answer`}{' '}
          <b>{t`as many tasks as possible.`}</b>
        </div>
        <div className={styles.button}>
          <BoldButton
            label={t`Start the test`}
            icon={PlayIcon}
            isIconFirst
            onClick={startGMA}
          />
        </div>
      </div>
    </WaveContainer>
  )
}

export default connect(R.converge(R.mergeLeft, [getGMA, getRespondent]), {
  startGMA,
})(AbilityExample)
